import { useModalStore } from '@/shared/lib';
import { ChangePasswordModal } from '../ui';

interface Props {
  onBack: () => void;
}

const useChangePasswordModal = () => {
  const { showDialogComponent } = useModalStore();

  const openChangePasswordModal = ({ onBack }: Props) => {
    showDialogComponent({
      component: <ChangePasswordModal onBack={onBack} />,
    });
  };

  return { openChangePasswordModal };
};

export { useChangePasswordModal };
